<template>
  <div class="verification-container">
    <div class="verification-table">
      <div class="verification-table-title">忘记密码</div>
      <div class="v-table-input-phone">
        <input type="text" v-model="userPhone" placeholder="手机号码">
      </div>
      <div class="v-table-input-number">
        <input v-model="telCode" autocomplete='off' placeholder="请输入验证码" >
        <input v-show="tcShow" class="aaaa" autocomplete='off' placeholder="" >
        <button v-show="canGetCode" @click="sendTelCode" class="clickBtn">发送验证码</button>
        <button v-show="!canGetCode" class="countBtn">{{count}}秒</button>
      </div>
      <div class="v-table-input-btn"><button @click="checkTelCode">提交</button></div>
    </div>
  </div>
</template>

<script>
  import {ApiSendTelCode, ApiCheckTelCode} from '../../../net/home/index.js'
  import {phoneFun, checkMobile} from '../../../untils/common.js'
  export default {
    data: function () {
      return {
        timer: null,
        count: 180,
        userPhone: '',
        telCode: '',
        canGetCode: true,
        tcShow: true
      }
    },
    methods: {
      checkPhone: function () {
        if (!phoneFun(this.userPhone)) {
          this.$message({
            message: '手机号码格式有误',
            type: 'warning'
          })
          return false
        }
        return true
      },
      setTimer: function () {
        clearInterval(this.timer)
        this.canGetCode = false
        this.timer = setInterval(()=>{
          if (this.count == 0) {
            this.canGetCode = true
            this.count = 180
            clearInterval(this.timer)
          }
          this.count --
        },1000)
      },
      sendTelCode: function () {
        if (!this.checkPhone()) {return}
        if (!this.canGetCode) {return}
        this.setTimer()
        ApiSendTelCode({tel: this.userPhone}).then(res=>{
          if (res.code == 200) {
            this.$message.success('验证码已发送')
          }
        })
      },
      checkTelCode: function () {
        if (!this.checkPhone()) {return}
        if (this.telCode.length != 6) {
          this.$message.warning('验证码格式有误')
          return
        }
        const prames = {
          tel: this.userPhone,
          telCode: this.telCode
        }
        ApiCheckTelCode(prames).then(res=>{
          if (res.code == 200) {
            this.$emit('toEdit', res.value.codeCheck)
          }
        })
      }
    },
    mounted: function () {
      setTimeout(()=>{
        this.tcShow = false
      }, 1000)

    },
    beforeDestroy: function () {
      clearInterval(this.timer)
    }
  }
</script>

<style scoped>
  .v-table-input-number .aaaa{
    width:0px;
    height: 0px;
    opacity: 0;
    position: absolute;
  }
  .verification-container{
  	width: 1140px;
  	margin: 0 auto;
  	margin-top: 20px;
  	height: 500px;
  	background: #fff;
  	border-radius: 6px;
  }
  .verification-table{
  	width: 320px;
  	margin: 0 auto;
  	overflow: hidden;
  }
  .verification-table-title{
  	font-size:20px;
  	color: #252525;
  	margin-top: 50px;
  }
  .v-table-input-phone{
  	width: 320px;
  	margin:0 auto;
  	margin-top: 24px;
  }
  .v-table-input-phone input{
  	width: 303px;
  	height: 38px;
  	border: 1px solid #ccc;
  	border-radius: 4px;
  	padding: 5px;
  	outline: none;
  	font-size: 16px;
    padding-left: 10px;
  }
  .v-table-input-number{
  	width: 320px;
  	margin:0 auto;
  	overflow: hidden;
  	margin-top: 24px;
  }
  .v-table-input-number input{
  	width: 185px;
  	height: 38px;
  	border: 1px solid #ccc;
  	border-radius: 4px;
  	padding: 5px;
  	outline: none;
  	float: left;
  	font-size: 16px;
    padding-left: 10px;
  }
  .v-table-input-number button{
  	width: 110px;
  	height: 48px;
  	border-radius: 4px;
  	background-color: #0AAC50;
  	border: none;
  	font-size: 16px;
  	color: #fff;
  	float: right;
  }
  .v-table-input-number .countBtn{
  	background-color: #ccc;
  }
  .v-table-input-btn{
  	width: 320px;
  	margin-top: 24px;
  }
  .v-table-input-btn button{
  	width: 320px;
  	height: 48px;
  	border-radius: 4px;
  	background-color: #0AAC50;
  	border: none;
  	color: #fff;
  	font-size: 16px;
  }
  .v-table-input-number button{
  	width: 110px;
  	height: 48px;
  	border-radius: 4px;
  	background-color: #0AAC50;
  	border: none;
  	font-size: 16px;
  	color: #fff;
  	float: right;
  	border: 1px solid transparent;
  	outline: none;
  }
  .v-table-input-btn{
  	width: 320px;
  	margin-top: 24px;
  }
  .v-table-input-btn button{
  	width: 320px;
  	height: 48px;
  	border-radius: 4px;
  	background-color: #0AAC50;
  	border: none;
  	color: #fff;
  	font-size: 16px;
  	border: 1px solid transparent;
  	outline: none;
  }
  .v-table-input-btn button:hover{
  	background-color: #019B3C;
  	cursor:pointer;
  }
  .v-table-input-number .clickBtn:hover{
  	background-color: #019B3C;
  	cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/ForGetPassword/children/phone.vue